import { BehaviorSubject, Subscription, tap, Subject, Observable } from 'rxjs';
import { VehicleRepairService } from '../../../services/vehicle-repair.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { IAvgTimeRepairer, VehicleRepairData } from '../../../models/vehicle-repair.model';

@Injectable()
export class VehicleRepairStoreService {
  vehicleRepairData: IAvgTimeRepairer[] = [];
  private vehicleRepairDataSubject = new Subject<any[]>();
  vehicleRepairDataObservable = this.vehicleRepairDataSubject.asObservable();
  private vehicleRepairDataDetailSubject = new BehaviorSubject<any>(null);
  VehicleRepairDataDetailObservable = this.vehicleRepairDataDetailSubject.asObservable();

  private _isLoading$ = new BehaviorSubject<boolean>(false);
  private _vehicleRepairDetailData$ = new BehaviorSubject<IAvgTimeRepairer[] | []>([]);

  // Observables
  public get isLoading(): Observable<boolean> {
    return this._isLoading$;
  }
  public get vehicleRepairDetailData(): Observable<IAvgTimeRepairer[] | []> {
    return this._vehicleRepairDetailData$; 
  }



  routeSubscription!: Subscription | undefined;
  regionId: string | undefined;
  departmentId: string | undefined;
  depotId: string | undefined;
  repairerId: string | undefined;

  constructor(
    private vehicleRepairService: VehicleRepairService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.routeSubscription = this.route.parent?.params.subscribe((res) =>
      this.onRouteChange(res)
    );
  }

  async onRouteChange(params: Params): Promise<void> {
    console.log('onRouteChange: ', params);

    // const range = this.route.snapshot.queryParamMap?.get("range")

    if (!params['departmentId'] || params['departmentId'].length <= 0) {
      this.router.navigate(['/']);
    }

    // const _params = this.globalData.generateApiQueryParams({
    //   range: range as IQueryFilterRange
    // });

    if (
      params['departmentId'] != this.departmentId ||
      params['regionId'] != this.regionId ||
      params['depotId'] != this.depotId
    ) {
      debugger
      this._isLoading$.next(true);
      this.vehicleRepairService
        .getVehicleRepairs(
          params['departmentId'] as string,
          params['regionId'] as string,
          params['depotId'] as string,
          this.getLast30DaysRange()
        )
        .pipe(
          tap((data) => {
            this._isLoading$.next(false);
            console.log('getVehicleRepairs: ', data);
            this.vehicleRepairData = this.objectToArrayWithKey(data);
            console.log('this.vehicleRepairData: ', this.vehicleRepairData);
            this.vehicleRepairDataSubject.next(this.vehicleRepairData);
            this._vehicleRepairDetailData$.next(this.vehicleRepairData);

            this.regionId = params['regionId'];
            this.departmentId = params['departmentId'];
            this.depotId = params['depotId'];
          })
        )
        .subscribe();
    }
  }

  getRepairerDetail(repairerId: string) {
    console.log(repairerId);
    this.vehicleRepairDataObservable.subscribe(() => {
      this.vehicleRepairDataDetailSubject.next(
        this.vehicleRepairData.find((vehicleDataObj) => {
          return vehicleDataObj.id === parseInt(repairerId);
        })
      );
    });
  }

  public getRepairerDetailNew(repairerId: string) {
    const item = this.vehicleRepairData.find((vehicleDataObj) => {
      return vehicleDataObj.id === parseInt(repairerId);
    })
    return item
  }



  objectToArrayWithKey(obj: any) {
    return Object.keys(obj).map((key) => {
      return {
        ...obj[key],
        name: key,
        averageTimeSpent: this.calculateAverageTimeSpent(
          obj[key]['vehicle_times']
        ),
      };
    });
  }

  calculateAverageTimeSpent(vehicle_times: any[]):number {
    let sum = 0;
    for (let i = 0; i < vehicle_times.length; i++) {
      sum += parseInt(vehicle_times[i].time_spent);
    }
    return sum / vehicle_times.length;
  }

  nullifySubject() {
    this.vehicleRepairDataDetailSubject.next(null);
  }

  getLast30DaysRange(): { date_start: string; date_end: string } {
    const today = new Date();

    // Get the current date formatted as YYYY-MM-DD
    const date_end = today.toISOString().split('T')[0];

    // Get the date 30 days ago
    const date_start = new Date(today);
    date_start.setDate(today.getDate() - 30);

    // Format the date 30 days ago as YYYY-MM-DD
    const startFormatted = date_start.toISOString().split('T')[0];

    return { 'date_start': startFormatted, 'date_end': date_end };
  }
}
